export var PushNotificationType = /*#__PURE__*/ function(PushNotificationType) {
    PushNotificationType["MyTurn"] = "my_turn";
    PushNotificationType["Rematch"] = "rematch";
    PushNotificationType["Reactivation"] = "reactivation";
    return PushNotificationType;
}({});
